export const create = {
  createSuccessfully: 'Create new admin successfully!',
}
